import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/options/default";

export class ReloadOptionsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload = null;

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand();
        return new ApiGenericResponse(res);
    }
}
